import axios from 'axios';

export const useProfile = () => {
  const updateProfile = async (profileData) => {
    try {
      const response = await axios.post('/api/user.php?action=update', profileData);
      return response.data;
    } catch (error) {
      console.error('프로필 업데이트 실패:', error);
      return {
        success: false,
        message: error.response?.data?.message || '프로필 업데이트에 실패했습니다.'
      };
    }
  };

  return {
    updateProfile
  };
};
